import {SVG} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text, View} from 'native-base';
import React from 'react';
import {Platform} from 'react-native';

import useHover from 'hooks/useHover';
import {OfferType} from 'models/Offer';
import {getOfferTypeIcon} from 'utils/getOfferTypeIcon';
import {useTheme} from 'styled-components/native';

interface OfferTypeItemProps {
  offerType: OfferType;
  isDisabled: boolean;
  isSelected: boolean;
  onPress: (offerType) => void;
}

const OfferTypeItem: React.FC<OfferTypeItemProps> = ({
  offerType,
  isDisabled,
  isSelected,
  onPress,
}) => {
  const {hovering, handleHoverIn, handleHoverOut} = useHover();
  const theme = useTheme();
  const {ghostWhite, white} = theme.colors;

  return (
    <Pressable
      alignItems="center"
      justifyContent="center"
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      bgColor={hovering || isSelected ? ghostWhite : white}
      borderRadius="8px"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      cursor={
        Platform.OS === 'web' ? (isDisabled ? 'not-allowed' : 'pointer') : null
      }
      disabled={isDisabled}
      opacity={isDisabled ? 0.5 : 1}
      onPress={() => onPress(offerType)}
      width="100px"
      height="70px"
      mx="3px"
      my="4px">
      <View
        alignItems="center"
        justifyContent="center"
        height="20px"
        width="20px"
        mb="6px">
        <SVG source={getOfferTypeIcon({isSelected, offerType})} />
      </View>
      <Text
        testID={`${offerType.toLowerCase().split(' ').join('-')}-offer-type`}
        textAlign="center"
        fontSize="11px"
        fontWeight={isSelected ? 'bold' : 'normal'}
        selectable={false}>
        {offerType}
      </Text>
    </Pressable>
  );
};

export default OfferTypeItem;
